import { Pipe, PipeTransform } from '@angular/core';
import { MachineSafetyPluginService } from './machine-safety.service';
@Pipe({
  name: 'machinesafetyyesno',
  standalone: false
})
export class MachineSafetyYesNoPipe implements PipeTransform {
  public yesNoOptions: any[];
  constructor(private service: MachineSafetyPluginService) {
    this.yesNoOptions = this.service.getYesNoOptions();
  }
  transform(id: string): any {
    if (!id) return '&nbsp;';

    return this.service.getValue(parseInt(id), this.yesNoOptions);
  }
}
